import { MaybeUndef } from 'types/UtilityTypes';

/**
 * Backend `specifications.transportTypeSource` when the email names no
 * equipment and nothing else (lane, customer, facility, service default)
 * decides it. The suggested `transportType` is then empty.
 */
export const TRANSPORT_TYPE_SOURCE_UNKNOWN = 'unknown';

/** Placeholder for every Builder equipment / transport type select. */
export const EQUIPMENT_PLACEHOLDER = 'Select equipment';

/** Inline error under the equipment field when the rep has not picked one. */
export const EQUIPMENT_REQUIRED_MESSAGE = 'Select the equipment for this load';

type SuggestedSpecsLike = MaybeUndef<{
  transportType?: MaybeUndef<string>;
  transportTypeSource?: MaybeUndef<string>;
}>;

/**
 * True when a Builder suggestion carries no usable equipment: the backend
 * marked the source "unknown", or the transport type is missing/blank.
 */
export function isSuggestedTransportTypeEmpty(
  specs: SuggestedSpecsLike
): boolean {
  if (!specs) {
    return true;
  }
  if (
    String(specs.transportTypeSource ?? '')
      .trim()
      .toLowerCase() === TRANSPORT_TYPE_SOURCE_UNKNOWN
  ) {
    return true;
  }
  return !String(specs.transportType ?? '').trim();
}

/**
 * The suggested transport type as-is (pass-through, no FE aliasing), or ''
 * when the suggestion has none. Forms must never replace '' with a default
 * (Van, first option, Truckload): the rep picks the equipment.
 */
export function suggestedTransportTypeOrEmpty(
  specs: SuggestedSpecsLike
): string {
  if (isSuggestedTransportTypeEmpty(specs)) {
    return '';
  }
  return String(specs?.transportType ?? '');
}

/** RHF `validate` for a required equipment field. */
export function validateEquipmentRequired(value: unknown): true | string {
  return String(value ?? '').trim() ? true : EQUIPMENT_REQUIRED_MESSAGE;
}
